import { useNavigate, useNavigation } from "react-router-dom";
import Link from "./Link.js";
import styled from "styled-components";
import { MoonLoader } from "react-spinners";
import goTo from "../../controllers/goTo.js";
import { Button, Tooltip } from "@mui/material";
import { useContext } from "react";
import Context from "../../Context.js";

const Text = styled.div`
  /* text-transform: lowercase; */
  font-weight: 700;
  display: flex;

  font-family: "Montserrat", sans-serif;

  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 12px;

  @media (max-width: 900px) {
    font-size: 11px;
  }
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function CustomButton({
  children,
  icon,
  onClick,
  href,
  style,
  variant,
  isLoading,
  isActive,
  onActiveStyle,
  disabled,
  onlyDesktop,
  customVariant,
  textStyle,
  iconStyle,
  surfaceColor = "var(--surface)",
  elementColor = "var(--element)",
}) {
  const { isMobile } = useContext(Context);

  if (onlyDesktop) {
    if (isMobile) return null;
  }
  if (href && !onClick) {
    onClick = () => {
      goTo(href)();
    };
  }

  if (!variant && !customVariant) {
    customVariant = "slightlyContained";
  }

  if (!style) style = {};

  if (disabled) {
    style = { ...style, opacity: 0.5, pointerEvents: "none" };
  }

  if (isActive && onActiveStyle) {
    style = { ...style, ...onActiveStyle };
  }

  if (isLoading) icon = <MoonLoader size="20px" color="var(--element)" />;

  if (icon)
    icon = <Icon style={{ color: elementColor, ...iconStyle }}>{icon}</Icon>;

  let additionalStyle = {};
  if (!children) {
    if (icon) {
      children = icon;
      icon = null;
      additionalStyle = { height: "45px", width: "45px", padding: 0 };
    }
  } else {
    children = (
      <Text style={{ color: elementColor, ...textStyle }}>{children}</Text>
    );
  }

  if (customVariant) {
    if (customVariant == "slightlyContained") {
      additionalStyle = {
        ...additionalStyle,
        background: surfaceColor,
        border: `1px solid var(--borderDim)`,
      };
    }
  }

  return (
    <Button
      onClick={theClick}
      style={{
        minWidth: "unset",
        padding: "10px 20px",
        gap: "10px",
        borderRadius: "50px",
        border: "1px solid var(--border)",
        boxShadow: "rgb(120 166 0 / 72%) 1px 5ppx 50px 1px",
        ...additionalStyle,
        ...style,
      }}
      variant={variant}
      onHover
      startIcon={icon}
    >
      {children}
    </Button>
  );

  function theClick(e) {
    e.preventDefault();

    if (onClick) onClick(e);
  }
}
